import { Routes } from "../../constants/Routes";
import BaseController from "../sharedControllers/BaseController";

/**
 * @namespace akademika.akamont.pages.notFound
 */
export default class NotFound extends BaseController {
  parentRoute = Routes.DASHBOARD;

  public goToDashboard() {
    this.navTo(Routes.DASHBOARD);
  }
}
